// eslint-disable-next-line no-empty
export const noop = (): void => {};

export enum StarRating {
  ZERO = 0,
  ONE = 1,
  TWO = 2,
  THREE = 3,
  FOUR = 4,
  FIVE = 5,
}
